import {EtsyListing, etsySettings} from '@coolcolduk/etsy';
import {Box, Grid, Paper, TextField} from '@mui/material';
import {useState} from 'react';
import {UserAccount} from '../../../__generated__/resolvers-types';
import EtsyUpdateListingSeoItemEditorFooter from './EtsyUpdateListingSeoItemEditorFooter';
import EtsyUpdateListingSeoItemEditorHeader from './EtsyUpdateListingSeoItemEditorHeader';
import EtsyUpdateListingSeoItemEditorTags from './EtsyUpdateListingSeoItemEditorTags';

export interface EtsyUpdateListingSeoItemEditorProps {
  listing: EtsyListing;
  user: UserAccount | null | undefined;
  onClose: () => void;
  onSave: (title: string, tags: string[]) => void;
}

export default function EtsyUpdateListingSeoItemEditor({
  listing,
  onClose,
  onSave,
  user,
}: EtsyUpdateListingSeoItemEditorProps) {
  const [title, setTitle] = useState(listing.title);
  const [tags, setTags] = useState(listing.tags || []);
  const [selectedTags, setSelectedTags] = useState<string[]>(listing.tags || []);

  const handleSave = () => {
    onSave(title, selectedTags);
    onClose();
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: 'rgba(0,0,0,0.5)',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        elevation={24}
        onClick={(e) => e.stopPropagation()}
        sx={{
          p: 2,
          maxWidth: '90%',
          maxHeight: '90vh',
          overflow: 'auto',
          position: 'relative',
          width: '80%',
        }}
      >
        <Grid container spacing={2} direction="column">
          <EtsyUpdateListingSeoItemEditorHeader listing={listing} user={user} />

          <TextField
            fullWidth
            label={`Title (${title.length}/${etsySettings.listing.title.maxLength})`}
            defaultValue={title}
            onChange={(e) => setTitle(e.target.value)}
            slotProps={{
              htmlInput: {
                maxLength: etsySettings.listing.title.maxLength,
              },
            }}
          />

          <EtsyUpdateListingSeoItemEditorTags
            tags={tags}
            selectedTags={selectedTags}
            setTags={setTags}
            setSelectedTags={setSelectedTags}
          />

          <EtsyUpdateListingSeoItemEditorFooter
            listing={listing}
            title={title}
            tags={selectedTags}
            onClose={onClose}
            onSave={handleSave}
          />
        </Grid>
      </Paper>
    </Box>
  );
}
